import { render } from "./IncentivesPage.vue?vue&type=template&id=5a5dd449&scoped=true"
import script from "./IncentivesPage.vue?vue&type=script&lang=js"
export * from "./IncentivesPage.vue?vue&type=script&lang=js"

import "./IncentivesPage.vue?vue&type=style&index=0&id=5a5dd449&scoped=true&lang=css"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5dd449"]])

export default __exports__